import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import InstructionPage from "./pages/InstructionPage";
import LandingPage from "./pages/LandingPage";
import NavSection from "./pages/NavBarSection/Navbar";
import AssessmentCrud from "./pages/CrudOpertations/AssessmentCrud";
import CreateAssessment from "./pages/CrudOpertations/CreateAssessment";
import UpdateAssessment from "./pages/CrudOpertations/UpdateAssessment";
import Reports from "./pages/Reports/Reports";
import AssessmentPage from "./pages/CrudOpertations/AssessmentPage";
import SignupPage from "./pages/LoginAndSignup/SignupPage";
import LoginPage from "./pages/LoginAndSignup/LoginPage";
import ResultMain from "./pages/Results/ResultMain";
import ViewExams from "./pages/Results/ViewExams";
import Answers from "./pages/Results/Answers";
import Admin from "./pages/LoginAndSignup/Admin";
import ProfileSettings from "./pages/Profile/ProfileSettings";
import DataPolicy from "./pages/DataPolicy/DataPolicy";
import Imprint from "./pages/Imprint/Imprint";
import Gwp from "./pages/Gwp/Gwp";
import SelfDeclaration from "./pages/Gwp/SelfDeclaration";
import TierRequirements from "./pages/Gwp/TierRequirements";
import TierRequirementsDE from "./pages/Gwp/TierRequirementsDE";
import Biofuel from "./pages/Gwp/Biofuel";
import Adaptation from "./pages/Adaptation/Adaptation";
import Footer from "./pages/Footer/Footer";
import FinancialExample from "./pages/Examples/FinancialExamples";
import UsersList from "./pages/Users/UsersList";
import Third from "./pages/LoginAndSignup/Third";
import CreateUser from "./pages/Users/CreateUser";
import UserRole from "./pages/Users/UserRole";
import UsersReview from "./pages/Users/UsersReview";
import AssessmentCrudUser from "./pages/CrudOpertations/AssessmentCrudUser";
import ReportsView from "./pages/Reports/ReportsView";
import ReportsExpertView from "./pages/Reports/ReportsExpertView";
import AssessmentCrudExpert from "./pages/CrudOpertations/AssessmentCrudExpert";
import ResultThird from "./pages/Results/ResultThird";
import ReportsThirdView from "./pages/Reports/ReportsThirdView";
import ProfilePassword from "./pages/Profile/ProfilePassword";
import ReportAssessment from "./pages/CrudOpertations/ReportAssessment";
import ReportsThirdUser from "./pages/Reports/ReportsThirdUser";
import RecoveryPasswordPage from "./pages/LoginAndSignup/RecoveryPassword";
import RecoveryPasswordTokenPage from "./pages/LoginAndSignup/RecoveryPasswordToken";
import CookieConsent from "react-cookie-consent";

function App() {
  return (
    <Router>
      <div className="App">
          <CookieConsent 
          location="bottom"
          buttonText="Accept!"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}           
        >
          This website uses only functional cookies.{" "}
          <span style={{ fontSize: "10px" }}></span>
        </CookieConsent>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/landing"
            element={
              <>
                <NavSection />
                <LandingPage />
              </>
            }
          />
          <Route
            path="/instructions"
            element={
              <>
                <NavSection />
                <InstructionPage />
              </>
            }
          />
          <Route
            path="/assessment"
            element={
              <>
                <NavSection />
                <AssessmentCrud />
              </>
            }
          />
          <Route
            path="/assessment/user"
            element={
              <>
                <NavSection />
                <AssessmentCrudUser />
              </>
            }
          />
          <Route
            path="/assessment/expert"
            element={
              <>
                <NavSection />
                <AssessmentCrudExpert />
              </>
            }
          />
          <Route
            path="/take-assessment"
            element={
              <>
                <NavSection />
                <AssessmentPage />
              </>
            }
          />
          <Route
            path="/create"
            element={
              <>
                <NavSection /> <CreateAssessment />{" "}
              </>
            }
          />
          <Route
            path="/update/:id"
            element={
              <>
                <NavSection /> <UpdateAssessment />
              </>
            }
          />
          <Route
            path="/reports"
            element={
              <>
                <NavSection /> <Reports />{" "}
              </>
            }
          />
          <Route
            path="/reports/view"
            element={
              <>
                <NavSection /> <ReportsView />{" "}
              </>
            }
          />
          <Route
            path="/reports/third/view"
            element={
              <>
                <NavSection /> <ReportsThirdUser />{" "}
              </>
            }
          />
          <Route
            path="/reports/third/view/:userId"
            element={
              <>
                <NavSection /> <ReportsThirdView />{" "}
              </>
            }
          />
          <Route
            path="/reports/expert/view"
            element={
              <>
                <NavSection /> <ReportsExpertView />{" "}
              </>
            }
          />
          <Route
            path="/reports/report/view/:reportId"
            element={
              <>
                <NavSection /> <ReportAssessment />{" "}
              </>
            }
          />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/recovery-password" element={<RecoveryPasswordPage />} />
          <Route path="/reset-password/:token" element={<RecoveryPasswordTokenPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/third" element={<Third />} />
          <Route
            path="/results"
            element={
              <>
                <NavSection />
                <ResultMain />{" "}
              </>
            }
          />
          <Route
            path="/results/third"
            element={
              <>
                <NavSection />
                <ResultThird />{" "}
              </>
            }
          />
          <Route
            path="/profile"
            element={
              <>
                <NavSection />
                <ProfileSettings />{" "}
              </>
            }
          />
          <Route
            path="/edit-password"
            element={
              <>
                <NavSection />
                <ProfilePassword />{" "}
              </>
            }
          />
          <Route
            path="/view-exams/:email"
            element={
              <>
                <NavSection />
                <ViewExams />{" "}
              </>
            }
          />
          <Route
            path="/datapolicy"
            element={
              <>
                <NavSection />
                <DataPolicy />{" "}
              </>
            }
          />
          <Route
            path="/imprint"
            element={
              <>
                <NavSection />
                <Imprint />{" "}
              </>
            }
          />
          <Route
            path="/gwp"
            element={
              <>
                <NavSection />
                <Gwp />{" "}
              </>
            }
          />
          <Route
            path="/tierrequirements"
            element={
              <>
                <NavSection />
                <TierRequirements />{" "}
              </>
            }
          />
          <Route
            path="/tierrequirementsDE"
            element={
              <>
                <NavSection />
                <TierRequirementsDE />{" "}
              </>
            }
          />
          <Route
            path="/SelfDeclaration"
            element={
              <>
                <NavSection />
                <SelfDeclaration />{" "}
              </>
            }
          />
          
          <Route
            path="/biofuel"
            element={
              <>
                <NavSection />
                <Biofuel />{" "}
              </>
            }
          />
          <Route
            path="/answers/:assessmentId"
            element={
              <>
                <NavSection />
                <Answers />{" "}
              </>
            }
          />
          <Route
            path="/adaptation-construction"
            element={
              <>
                <NavSection />
                <Adaptation category="construction" />{" "}
              </>
            }
          />
          <Route
            path="/adaptation-energy"
            element={
              <>
                <NavSection />
                <Adaptation category="energy" />{" "}
              </>
            }
          />
          <Route
            path="/adaptation-manufacturing"
            element={
              <>
                <NavSection />
                <Adaptation category="manufacturing" />{" "}
              </>
            }
          />
          <Route
            path="/example-manufacturing"
            element={
              <>
                <NavSection />
                <FinancialExample type="manufacturing" />{" "}
              </>
            }
          />
          <Route
            path="/example-energy"
            element={
              <>
                <NavSection />
                <FinancialExample type="energy" />{" "}
              </>
            }
          />
          <Route
            path="/example-construction"
            element={
              <>
                <NavSection />
                <FinancialExample type="construction" />{" "}
              </>
            }
          />
          <Route
            path="/users"
            element={
              <>
                <NavSection />
                <UsersList />
              </>
            }
          />
          <Route
            path="/users/review"
            element={
              <>
                <NavSection />
                <UsersReview />
              </>
            }
          />
          <Route
            path="/users/create"
            element={
              <>
                <NavSection />
                <CreateUser />
              </>
            }
          />
          <Route
            path="/users/:id/role/:fromRole"
            element={
              <>
                <NavSection />
                <UserRole />
              </>
            }
          />
          
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
